import React from "react";
import { ErrorMessage } from "common/components/StyledElements";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <ErrorMessage>Something went wrong.</ErrorMessage>;
    }

    return children;
  }
}

export default ErrorBoundary;
